webpackJsonp([40],{

/***/ 1503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsSorting_vue__ = __webpack_require__(1707);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a0d63d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsSorting_vue__ = __webpack_require__(1754);
function injectStyle (ssrContext) {
  __webpack_require__(1752)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52a0d63d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsSorting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a0d63d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsSorting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(122);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['systemId', 'systemName'],
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    data: function data() {
        return {
            data: [],
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [{ text: this.$t('SettingsSorting'), id: 'table-settings-title' }, { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' }, { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' }, { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' }, 'Search'],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "Menu"
            },
            customAttributes: { class: 'customcss' },
            sortingModes: [],
            sortByWeightRangeTemplate: function sortByWeightRangeTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('sortByWeightRangeTemplate', {
                        template: '\n                            <div>\n                              <p class="mb-0">{{ range1 }}</p>\n                              <p class="mb-0">{{ range2 }}</p>\n                              <p class="mb-0">{{ range3 }}</p>\n                            </div>\n                        ',
                        data: function data() {
                            return {
                                data: {}
                            };
                        },
                        computed: {
                            range1: function range1() {
                                return this.$t("From") + " 0kg " + this.$t("to") + " " + this.data.sortingByWeightValue1 + " " + this.$t("goToGate") + " " + this.data.sortByWeightGate1 + ".";
                            },
                            range2: function range2() {
                                return this.$t("From") + " " + this.data.sortingByWeightValue1 + "kg " + this.$t("to") + " " + this.data.sortingByWeightValue2 + " " + this.$t("goToGate") + " " + this.data.sortByWeightGate2 + ".";
                            },
                            range3: function range3() {
                                return this.$t("Over") + " " + this.data.sortingByWeightValue2 + "kg " + this.$t("goToGate") + " " + this.data.sortByWeightGate3 + ".";
                            }
                        },
                        mounted: function mounted() {}
                    })
                };
            },
            autoTaraWeightTemplate: function autoTaraWeightTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('autoTaraWeightTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.autoTaraWeight}}kg\n                          </div>\n                          <div v-else>\n                            {{data.autoTaraWeight}}lb\n                          </div>\n                      '
                    })
                };
            },
            animalWeightCalibrationTemplate: function animalWeightCalibrationTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('animalWeightCalibrationTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.animalWeightCalibration}}kg\n                          </div>\n                          <div v-else>\n                            {{data.animalWeightCalibration}}lb\n                          </div>\n                      '
                    })
                };
            },
            minWeightOnPlatformTemplate: function minWeightOnPlatformTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('minWeightOnPlatformTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.minWeightOnPlatform}}kg\n                          </div>\n                          <div v-else>\n                            {{data.minWeightOnPlatform}}lb\n                          </div>\n                      '
                    })
                };
            },
            autoTaraTimerTemplate: function autoTaraTimerTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('autoTaraTimerTemplate', {
                        template: '\n                          <div>\n                            {{data.autoTaraTimer}}s\n                          </div>\n                      '
                    })
                };
            },
            noDecisionTimeTemplate: function noDecisionTimeTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('noDecisionTimeTemplate', {
                        template: '\n                          <div>\n                            {{data.noDecisionTime}}s\n                          </div>\n                      '
                    })
                };
            },
            weightTimeTemplate: function weightTimeTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('weightTimeTemplate', {
                        template: '\n                          <div>\n                            {{data.weightTime}}s\n                          </div>\n                      '
                    })
                };
            },
            sprayTimeTemplate: function sprayTimeTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('sprayTimeTemplate', {
                        template: '\n                          <div>\n                            {{data.sprayTime}}ms\n                          </div>\n                      '
                    })
                };
            },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var sortingSettingsHistory;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.sortingModes.push({
                                    Name: _this.$t("OnlySortByAnimalSettings"),
                                    Value: 85
                                });
                                _this.sortingModes.push({
                                    Name: _this.$t("WeightAndSortByAnimalSettings"),
                                    Value: 0
                                });
                                _this.sortingModes.push({
                                    Name: _this.$t("WeightAndSortByWeightRange"),
                                    Value: 170
                                });

                                _this.data = [];
                                _this.$emit('spin', true);

                                _context.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_63" /* getSortingSettingsHistory */])(_this.systemId);

                            case 7:
                                sortingSettingsHistory = _context.sent;

                                sortingSettingsHistory.forEach(function (item) {
                                    return item.sortingMode = _this.sortingModes.find(function (m) {
                                        return m.Value == item.weightTurnedOn;
                                    }).Name;
                                });
                                _this.data = sortingSettingsHistory;

                                _this.$emit('spin', false);

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case "table-system-title":
                    this.$router.push({
                        name: "systems"
                    });
                    break;
                case "table-settings-title":
                    this.getData();
                    break;
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return this.getData();

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1752:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1753);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("7cecc348", content, true, {});

/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SettingsSorting.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","min-width":"1280px","padding":"10px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","flex":"1","height":"100%","min-width":"1280px"}},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"updateDate","headerText":_vm.$t('UpdateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170","type":"datetime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"autoTaraTimer","headerText":_vm.$t('AutoTaraTimer'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170","template":_vm.autoTaraTimerTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"autoTaraWeight","headerText":_vm.$t('AutoTaraWeight'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170","template":_vm.autoTaraWeightTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"animalWeightCalibration","headerText":_vm.$t('AnimalWeightCalibration'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"230","template":_vm.animalWeightCalibrationTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"errorGate","headerText":_vm.$t('ErrorGate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"130"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"noDecisionTime","headerText":_vm.$t('NoDecisionTime'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170","template":_vm.noDecisionTimeTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"sprayTime","headerText":_vm.$t('SprayTime'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"130","template":_vm.sprayTimeTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"minWeightOnPlatform","headerText":_vm.$t('MinWeightOnPlatform'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"210","template":_vm.minWeightOnPlatformTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"weightTime","headerText":_vm.$t('WeightTime'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"140","template":_vm.weightTimeTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"sortingMode","headerText":_vm.$t('SortingMode'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"160"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"wagonAutoCloseTime","headerText":_vm.$t('SortByWeightRanges'),"textAlign":"Left","customAttributes":_vm.customAttributes,"template":_vm.sortByWeightRangeTemplate,"width":"230"}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/40.ae5cee83a471091752f3.js